import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

export type InfoSmallProps = {
  fill?: string;
  tabIndex?: number;
  className?: string;
};

export default function InfoSmall({
  fill = colors.neutral10,
  tabIndex,
  className,
}: InfoSmallProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      tabIndex={tabIndex}
      className={cn('h-[24px] w-[24px]', className)}
    >
      <g clipPath="url(#clip0_201_9188)">
        <path
          d="M9 7C9 7.552 8.552 8 8 8C7.448 8 7 7.552 7 7C7 6.448 7.448 6 8 6C8.552 6 9 6.448 9 7Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5 10C15.5 14.1421 12.1421 17.5 8 17.5C3.85786 17.5 0.5 14.1421 0.5 10C0.5 5.85786 3.85786 2.5 8 2.5C12.1421 2.5 15.5 5.85786 15.5 10ZM8 16C11.3137 16 14 13.3137 14 10C14 6.68629 11.3137 4 8 4C4.68629 4 2 6.68629 2 10C2 13.3137 4.68629 16 8 16Z"
          fill={fill}
        />
        <rect x="7" y="9" width="2" height="5" rx="1" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_201_9188">
          <rect width="24px" height="24px" fill={fill} transform="translate(0 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}
